import { RotateLeftOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'

import { MenuButton } from '../../../MenuButton'
import { useImageCardStore } from '../../Store/hooks/useStore'

export const RotateButton = () => {
  const { doRotate } = useImageCardStore(state => pick(state, ['doRotate']))

  return (
    <MenuButton
      icon={<RotateLeftOutlined />}
      tooltip='逆时针旋转90度'
      onClick={doRotate}
    />
  )
}
